/*@ngInject*/
const SortUtil = function () {

    function getItemValue(item, sortColumn) {
        let itemValue = (_.isArray(sortColumn) && !_.isNull(item[sortColumn[0]])) ? item[sortColumn[0]][sortColumn[1]] : item[sortColumn];
        return _.isString(itemValue) ? _.lowerCase(itemValue) : itemValue;
    }

    this.naturalSortObject = function(sortColumn) {
        return function(itemA, itemB) {
            let arrayA = [], arrayB = [],
                itemAValue = getItemValue(itemA, sortColumn),
                itemBValue = getItemValue(itemB, sortColumn),
                shiftedArrayA,
                shiftedArrayB,
                comparedArrays;

            _.replace(itemAValue, /(\d+)|(\D+)/g, function(_, $1, $2) {
                arrayA.push([$1 || Infinity, $2 || '']);
            });

            _.replace(itemBValue, /(\d+)|(\D+)/g, function(_, $1, $2) {
                arrayB.push([$1 || Infinity, $2 || '']);
            });

            while(arrayA.length && arrayB.length) {
                shiftedArrayA = arrayA.shift();
                shiftedArrayB = arrayB.shift();
                comparedArrays = (shiftedArrayA[0] - shiftedArrayB[0]) || shiftedArrayA[1].localeCompare(shiftedArrayB[1]);

                if(comparedArrays) { return comparedArrays; }
            }

            return arrayA.length - arrayB.length;
        };
    };

};

angular.module('umCore').service('sortUtil', SortUtil);
